import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M7.5 12.875L4.625 10l-.875.875 3.75 3.75 8.75-8.75L15.375 5z'],
  height: 20,
  width: 20,
});
